import AppReducer from "./reducers";

const appsReducers = {
  allApps: AppReducer.allAppsReducer,
  appInfo: AppReducer.appReducer,
};

export { appsReducers };
